export const headersForDataList = [
    {
        title: 'Passport',
        reduxProperty: 'passport',
        apiProperty: 'passport',
    },
    {
        title: 'Bank statement',
        reduxProperty: 'accountStatement',
        apiProperty: 'account_statement',
    },
    {
        title: 'The document confirming the residence permit',
        reduxProperty: 'registration',
        apiProperty: 'registration',
    },
    {
        title: 'The document certifying the ownership of the account',
        reduxProperty: 'accountOwnership',
        apiProperty: 'ownership',
    },
]
